import { useTranslation } from 'react-i18next'

import { useNonprofitPartnerTagAssignments } from '../useNonprofitPartnerTagAssignments/useNonprofitPartnerTagAssignments'
import { useSpotlightedOrgs } from '../useSpotlightedOrgs/useSpotlightedOrgs'

export const useAlumniBadge = (organisationId?: string | null) => {
  const { t } = useTranslation()
  const assignments = useNonprofitPartnerTagAssignments()
  const { partnerLogo, partnerName } = useSpotlightedOrgs()

  const matchingTag =
    organisationId && Array.isArray(assignments)
      ? assignments.find(assignment => assignment.entityIds.includes(organisationId))
      : null

  // Intentionally returns null when tag has no image and partner has no logo — badge requires a visual asset to render
  const alumniBadge = matchingTag ? matchingTag.tag.image || partnerLogo || null : null
  const alumniBadgeTooltip = alumniBadge ? t('workplace_giving.common.alumniOrganisation', { partnerName }) : null

  return {
    alumniBadge,
    alumniBadgeTooltip
  }
}
